export const remarkCode = {
  REJECT: 'RJT',
  ACCEPT: 'ACP',
  EDIT: 'EDT'
};
